/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取用户收货地址列表以及相应的快递费用信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  addrWithPriceDTO: member.AddrWithPriceDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.AddrWithPriceRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/addresswithprice`,
    data: addrWithPriceDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
